import { whatIfInnerSelector } from '../../WhatIfsSelector';

const educationDurationYearsSelector = (state, props) =>
  whatIfInnerSelector(state, props).EducationDurationYears;

export default educationDurationYearsSelector;
